import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Product } from '@utils/product';
import { TitleAndSubtitle, ProductImage } from 'audamatic-ui';
import Link from '../../base_link/component';
import './styles/styles.scss';

class BannerCollection extends Component {
  get productCollection() {
    const { productSelection, products } = this.props;
    const collection = products || productSelection || [];
    return collection.slice(0, 3);
  }

  get booklist() {
    return this.productCollection.map((_product, index) => {
      const product = new Product(_product);
      return (
        <div className="product-image-wrapper">
          <ProductImage key={`cover_${index}`} product={product} />
        </div>
      );
    });
  }

  render() {
    const { text1, text2, link = '#' } = this.props;
    return (
      <Link href={link} className="collection-banner banner">
        <div className="booklist-images">
          <div className="centered-images">{this.booklist}</div>
        </div>
        <div className="align-to-bottom-container">
          <div className="collection-headings">
            <TitleAndSubtitle
              title={text1}
              subtitle={text2}
            />
          </div>
        </div>
      </Link>
    );
  }
}

BannerCollection.propTypes = {
  text1: PropTypes.string,
  text2: PropTypes.string,
  link: PropTypes.string,
  products: PropTypes.array,
  productSelection: PropTypes.array,
};


export default BannerCollection;
